import React, { useState,useEffect, useContext } from 'react'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { useNavigate,Link , useParams  } from 'react-router-dom'
import './createtemp.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faArrowRight, faBookmark, faPlus, faTrashCan, faClose } from '@fortawesome/free-solid-svg-icons'
import BackLoader from '../../../components/backloader'
import * as Constants from '../../../constants';
import { ShareContext } from '../../../context/ShareContext'
import TopBar from '../../../components/topbar'
import moment from 'moment'
import JisAlert from '../../../components/jisalert'
import JisPrompt from '../../../components/jisprompt'


function Placeholder() {
    const { profile } = useContext(ShareContext)
    const [openPrev, setOpenPrev] = useState(false)
    const [selectedPlaceholders, setSelectedPlaceholders] = useState([])
    const [isLoading,setIsLoading]= useState(false);
    const [alert, setAlert] = useState({open:false})
    const holderUrl= `${Constants.apiUrl}/gazette/templateholders`;
    const [upHolders, setUpHolders ] =useState([]); //this list is coming from all of them
    const [holder, setHolder] = useState({});
    const [activeh, setActiveHolder] =useState({});
    const [prompt, setPrompt] =useState({open:false, title:'', subtitle:''});

    const openPrevPlaceHolders = () => {
        setOpenPrev(!openPrev)
    }

    

    const checkedPrev = (id) => {
        const itemPicked = dummyPlaceHolders.find((item) => item.id === id);
        const newArr = [...selectedPlaceholders];
    
        // Check if the item is already in the array
        const index = newArr.findIndex((item) => item.id === id);
    
        if (index !== -1) {
            // If the item is found, remove it from the array
            newArr.splice(index, 1);
        } else {
            // If the item is not found, add it to the array
            newArr.push(itemPicked);
        }
    
        setSelectedPlaceholders(newArr);
    };
    
    console.log(selectedPlaceholders);

    const dummyPlaceHolders = [
        {
            name: 'Append CFO Initial',
            id: 0
        },
        {
            name: 'Enter Division',
            id: 1
        },
        {
            name: 'Enter Suit Number',
            id: 2
        },
        {
            name: 'Enter Claimant',
            id: 3
        },
        {
            name: 'Enter Defendant',
            id: 4
        },
        {
            name: 'Enter Affidavit in Support Type',
            id: 5
        },
        {
            name: 'Enter Deponent Full Name',
            id: 6
        },
        {
            name: 'Enter Gender',
            id: 7
        },
        {
            name: 'Enter Religion',
            id: 8
        },
        {
            name: 'Enter Occupation',
            id: 9
        },
        {
            name: 'Enter Address',
            id: 10
        },
    ]

    const onOk =()=>{
        setAlert({open:false});
    }
    const onSave =async(e)=>{
        //write the txt to pdf
       // setIsDialog(false)
        //this will save only item added
        e.preventDefault();
        setIsLoading(true);
        try {
            const theurl=`${Constants.apiUrl}/gazette/templateholder`;
           

          
    
            const resp = await fetch(theurl, {
              method: 'POST',
              body: JSON.stringify(holder),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0 ) {
              //on this back

              setAlert(  {open:true,title:'Placeholder', subtitle:"Saved successfully", onOk});
              var holderss=[...selectedPlaceholders, {...holder,id:responseData.id}];
              setSelectedPlaceholders(holderss);
              //add item to list

                setHolder({});
            }else {
                setAlert(  {open:true,title:'Placeholder', subtitle:responseData.status, onOk});
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
           
          }
    }

    const onRemove =async()=>{
        //write the txt to pdf
       // setIsDialog(false)
        //this will save only item added
        setPrompt({...prompt, open:false});
        setIsLoading(true);
        try {
            const theurl=`${Constants.apiUrl}/gazette/templateholder/${activeh.id}/remove`;
            const resp = await fetch(theurl, {
              method: 'POST',
              body: JSON.stringify(holder),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0 ) {
              //on this back
              setAlert(  {open:true,title:'Placeholder', subtitle:"Delete successfully", onOk});
                //filter one off the table
                const pp = selectedPlaceholders.filter((c) => c.id !=activeh.id) ;
                setSelectedPlaceholders(pp);
                setActiveHolder({});
            }else {
                setAlert(  {open:true,title:'Placeholder', subtitle:responseData.status, onOk});
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
           
          }
    }
    
    const onReadyToDelete= (holder)=>{
        setActiveHolder(holder);
        setPrompt({open:true,title:'', subtitle:`Are you sure you want to delete ${holder.placeHolder} with name: ${holder.name}`,
       onCancel:()=>{setPrompt({...prompt, open:false})},}); 
   }

   const navigate = useNavigate();
    useEffect(() => {
        LoadHolders();
      }, []);

    const LoadHolders=()=>{
        setIsLoading(true);
        fetch(holderUrl, {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
            },
          })
            .then((resp) => resp.json())
            .then((data) => {
                setIsLoading(false);
                if(data.code==0){
                   
                    setUpHolders(data.holders);
                    setSelectedPlaceholders(data.holders);
                }
                
            })
            .catch(error => {
                console.error(error);
                setIsLoading(false);
            })
    }
    

  return (
    <div className='create-temp-dm'>
        <Sidebar />
        <div className="body">
           
            <TopBar title="Home/Placeholder" />
            <div className="back" onClick={() => window.history.back()}>
                <Link><FontAwesomeIcon icon={faAngleLeft} /> Back</Link>
            </div>
            <div className="dashboard-view">
                <h2>Setup Template Placeholders</h2>
                <div className="create-box">
                    <div className="left-form">
                        <form className="form-body" onSubmit={onSave}>
                            <div className="form-inp">
                                <label htmlFor="placeholderName">Placeholder Name</label>
                                <input type="text" placeholder='e.g Firstname placeholder' id='placeholderName' value={holder.name} onChange={(e)=> setHolder({...holder, name:e.target.value})} required/>
                            </div>
                            <div className="form-inp">
                                <label htmlFor="placeholderText">Placeholder Text</label>
                                <input type="text" placeholder='e.g [FIRSTNAME]' id='placeholderText' value={holder.placeHolder} onChange={(e)=> setHolder({...holder, placeHolder:e.target.value})} required />
                            </div>
                            <div className="form-inp">
                                <label htmlFor="typetemp">Placeholder Name</label>
                                <select id="typetemp" value={holder.type}  onChange={(e)=> setHolder({...holder, type:e.target.value})} required>
                                    <option value="" disabled selected>--Select Type--</option>
                                    <option value="TEXT[NORMAL]">TEXT[NORMAL]</option>
                                    <option value="TEXT[TEXTAREA]">TEXT[TEXTAREA]</option>
                                    <option value="TEXT[MULTIPLE-INPUT]">TEXT[MULTIPLE-INPUT]</option>
                                    <option value="TEXT[MULTIPLE-TEXTAREA]">TEXT[MULTIPLE-TEXTAREA]</option>
                                    <option value="[DATE-TIME-STAMP]">[DATE-TIME-STAMP]</option>
                                    <option value="[DATE]">[DATE]</option>
                                    <option value="[TIME]">[TIME]</option>
                                    <option value="[DATETIME]">[DATETIME]</option>
                                    <option value="UPLOADED MEDIA[IMAGE]">UPLOADED MEDIA[IMAGE]</option>
                                   
                                </select>
                            </div>
                            <div className="form-inp">
                                <label htmlFor="formHint">Hint</label>
                                <input type="text" id='formHint' value={holder.hint} onChange={(e)=> setHolder({...holder, hint:e.target.value})} required/>
                            </div>
                            <button className="viewPrev" type='submit'><FontAwesomeIcon icon={faPlus} /> Add Placeholder</button>
                            {/* <button className='viewPrev' onClick={() => openPrevPlaceHolders()}><FontAwesomeIcon icon={faBookmark} /> View Existing Placeholders</button> */}
                        </form>
                       {/*  <Link to='/edm/create-temp/doc-create'><button className="red">Next <FontAwesomeIcon icon={faArrowRight} /></button></Link> */}
                    </div>
                    { selectedPlaceholders.length > 0 ? <div className="right-placeholders">
                        <h3>Added Placeholders</h3>
                        <div className="added-items">
                            {
                                selectedPlaceholders.map((item, id) => { return(
                                  <div key={id}>
                                    <div className="placeholder">
                                        <p>{item.name} | {item.placeHolder} | {item.hint}</p>
                                        <FontAwesomeIcon icon={faTrashCan} className='trash' onClick={()=>onReadyToDelete(item)}/>
                                    </div>
                                    
                                    </div>
                                  
                                )})
                            }
                        </div>
                    </div> : null}
                </div>
               
            </div>
            <div className={ openPrev ? "select-prev open" : "select-prev"}>
                <div className="select-wrapper">
                    <div className="heading">
                        <h2>Select from existing placeholders below</h2>
                        <div className="icon" onClick={() => openPrevPlaceHolders()}>
                            <FontAwesomeIcon icon={faClose} />
                        </div>
                    </div>
                    <div className="prev-place">
                        {
                            dummyPlaceHolders.map((item, id) => {
                                return (
                                    <div className="item" key={id}>
                                        <input
                                            type="checkbox"
                                            id={item.id}
                                            onChange={() => checkedPrev(item.id)}
                                            // You can also use checked={item.isChecked} if you have a checked state in your item object
                                        />
                                        <label htmlFor={item.id}>{item.name}</label>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="pagination">
                        <div className="prev">
                            <FontAwesomeIcon icon={faAngleDoubleLeft} />
                            <p>Previous</p>
                        </div>
                        <div className="page-btns">
                            <button>1</button>
                            <button>2</button>
                            <button>3</button>
                        </div>
                        <div className="prev">
                            <p>Next</p>
                            <FontAwesomeIcon icon={faAngleDoubleRight} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {alert.open && <JisAlert {...alert}/>}  
          <BackLoader open={isLoading}  />
          <JisPrompt {...prompt} onOk={onRemove}>
            <h4 style={{margin:8}}>{prompt.subtitle}</h4>
        </JisPrompt>
    </div>
  )
}

export default Placeholder